module.exports = __webpack_public_path__ + "img/Quickbooks_mobile-screenshot.9cad0078.png";